import { exportAuditTrailCsv, ExportAuditTrailParams } from '@brands/services/audit_trails/exportAuditTrailCsv';

export const triggerAuditTrailCsvDownload = async (params?: ExportAuditTrailParams): Promise<void> => {
  const blob = await exportAuditTrailCsv(params);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'audit_trail.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
